module.exports = __webpack_public_path__ + "images/king-kam-237535300b5e162ffe2eb1b5266e9b6b.png";